import AppRoute from "models/AppRoute"

const SchedulerRoute = new AppRoute({
    route: "/scheduler",
    navbar: true,
    authRequired: true,
})

export default SchedulerRoute
